module.exports = "<input [(ngModel)]=\"params.value\" [disabled]=\"isDisable()\" (focusout)=\"onValueChange($event)\">"